// Remote 모듈 매니페스트
// Core 로더가 이 객체를 읽어 라우터/스토어/네비에 주입한다.
import routes from "./routes";

export default {
  code: "REMOTE", // master_module.ExternalValue
  appCode: "REMOTE_APP", // 권한 매핑 (Auth 서버 identity_user_application)
  name: "Remote",
  routes, // AppShell children 으로 주입
  store: {}, // TODO: Remote 도메인 스토어 이식 시 { remote: store }
  // SideNav 그룹/메뉴 (7단계에서 /api/core/nav 권한 필터로 대체 예정)
  nav: {
    code: "REMOTE",
    // i18n 키 (AppSideNav 가 $t 로 렌더). remoteNav 네임스페이스 = core/i18n/locales
    name: "remoteNav.title",
    menus: [
      { name: "remoteNav.collaborationZone", path: "/remote/dashboard" },
      // path 대신 action → 클릭 시 라우팅 없이 전역 모달(협업 Space 생성 팝업) 오픈
      { name: "remoteNav.zoneCreation", action: "remote:createSpace" },
      { name: "remoteNav.history", path: "/remote/history" },
      { name: "remoteNav.settings", path: "/remote/settings" },
      { name: "remoteNav.members", path: "/remote/members" },
    ],
  },
  i18n: {},
};
